module.exports = __webpack_public_path__ + "static/media/hyundai-logo.6d1b303e.svg";